// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';


import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import CallIcon from '@material-ui/icons/Call';
import CallEndIcon from '@material-ui/icons/CallEnd';
import MicOffIcon from '@material-ui/icons/MicOff';

// import * as serviceSelectors from './selectors';
// import * as serviceActions from './actions';
import * as coreSelectors from '../core/selectors';
import * as phoneSelectors from './selectors';
import * as phoneActions from './actions';

// import * as ServiceIcons from '../service/Icons';

import * as Formatters from '../ui/Formatters';
// import PhoneTextField from '../ui/PhoneTextField';
import { withTranslation } from 'react-i18next';
import PhoneTextFieldWithFlag from '../ui/PhoneTextFieldWithFlag';
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

const styles = theme => ({
  popper : {
    '& .MuiPopover-paper' : {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
      borderStyle: 'solid',
      borderRadius: 20,
      overflow: 'hidden',
      // maxWidth: 250,
      // minWidth: 250,
    },

  },
  numberSelect : {
    fontFamily: 'Sofia'
  },
  numberEntry : {
  },
  button : {
    paddingLeft:  20,
    paddingRight:  20,
  },
  raisedIcon : {
    height: 60,
    width: 60,
    borderRadius: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: theme.shadows[8],
  },
  title : {
    ...theme.typography.h5,
    fontFamily: 'Sofia-bold',
  },
  keyPadButtonBox : {
    padding: 0,
  },
  keyPadButton : {
    margin: 0,
    minWidth: 50,
    maxWidth: 50,
    minHeight: 50,
    maxHeight: 50,
    // backgroundImage: 'none',
    borderRadius: 10,
    lineHeight: 1.1,
    padding: 0,   
    fontFamily: 'Sofia' ,
    color: theme.palette.primary.contrastText,
    // backgroundColor: theme.palette.primary.main,
    '&:hover' : {
      // backgroundColor: theme.palette.secondary.main,
    },
    '& .MuiButton-label': {
      display: 'block',
      textAlign: 'center',
    },
  },
  keyPadNumber : {
    ...theme.typography.body1,
    fontFamily: 'Sofia-bold',
  },
  keyPadLetters : {
    ...theme.typography.caption,
  },
    
});


/*
 * Phone control pad
 */

class PhonePad extends Component {
  buttonText=[
    { value : '1', letters: '' },
    { value : '2', letters: 'ABC' },
    { value : '3', letters: 'DEF' },
    { value : '4', letters: 'GHI' },
    { value : '5', letters: 'JKL' },
    { value : '6', letters: 'MNO' },
    { value : '7', letters: 'PQRS' },
    { value : '8', letters: 'TUV' },
    { value : '9', letters: 'WXYZ' },
    { value : '*', letters: '' },
    { value : '0', letters: '' },
    { value : '#', letters: '' },
  ];
  
  state = {
    phoneNumberId : '',
    open : false,
    region: 'us'
  }

  keyPad = (number) => {
    /* Simulate typing into the phone number box if not on a call */

    if (this.props.callState !== 'open') {
      if (typeof(this.insertPhoneDigit) === 'function') {
        this.insertPhoneDigit(number);
      }
    } else {
      /* If on the call send a DTMF digit */
      this.props.dtmf(number);
    }
  }

  setInsertFunction = (insertFunction) => {
    this.insertPhoneDigit = insertFunction;
  }

  componentDidUpdate() {
    if (this.props.phoneOpen && !this.state.open) {
      this.setState({open: true});
    }
    this.defaultPhoneNumber();
  }

  componentDidMount() {
    this.defaultPhoneNumber();
  }

  startOutcall = () => {
    this.props.outcall(this.state.phoneNumberId, this.props.outdialNumber);
  }

  changeRegion = (region) => {
    this.setState({region: region})
  }

  defaultPhoneNumber = () => {
    /* If the phone number is not set, see if their selection is stored */
    if (!Boolean(this.state.phoneNumberId) && localStorage.getItem("phoneNumberId")) {
      this.setState({phoneNumberId: Number(localStorage.getItem("phoneNumberId"))});
      return;
    }
    
    /* Unselect if they no longer have access for some reason */
    if (Boolean(this.state.phoneNumberId)) {
      let number = this.props.user.patchNumbers
                       .find(number => number.phoneNumberId === this.state.phoneNumberId);
      if (!Boolean(number)) {
        localStorage.removeItem('phoneNumberId');
        this.setState({phoneNumberId : ''});
      }
      return;
    }
    /* Pick the first one if none selected */
    if (this.props.user && this.props.user.patchNumbers.length > 0) {
      this.setState({phoneNumberId : this.props.user.patchNumbers[0].phoneNumberId});
      localStorage.setItem('phoneNumberId', String(this.props.user.patchNumbers[0].phoneNumberId));
    }
  }

  phoneNumberChanged = (phoneNumberId) => {
    localStorage.setItem('phoneNumberId', String(phoneNumberId));
    this.setState({ phoneNumberId });
  }

  checkPhoneNumber(phoneNumber){
    // if(phoneNumber.length < 10){
    //   return false;
    // }
    try{
      phoneUtil.parse(phoneNumber);
      return phoneUtil.isValidNumberForRegion(phoneUtil.parse(phoneNumber), this.state.region.toUpperCase())
    } catch(error){
      return false;
    }
  }

  render() {
    // eslint-disable-next-line    
    const { classes, user, phoneOpen, setPhoneOpen, anchorEl, callState,
            hangup, toggleMute, phoneMuted, outdialNumber, isMobile} = this.props;
    // let callEnabled=!Boolean(phoneOutcall.outcallNumber);
    let callEnabled = false;
    if (Boolean(this.state.phoneNumberId) && this.checkPhoneNumber(outdialNumber)) {
      callEnabled=true;
    }
    const phonePadPositions = {
      'anchor': {
        anchorEl: anchorEl,
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'bottom'
        }
      },
      'fixed': {
        anchorPosition: {
          top: 10,
          left: 10
        },
        anchorOrigin: {
          horizontal: 'right',
          vertical: 'top'
        }
      }
    }
    return(
      <MuiCore.Popover open={phoneOpen}
                        {...phonePadPositions[isMobile?'fixed':'anchor']}
                       transformOrigin = {{
                         vertical : 'top',
                         horizontal : 'left',
                       }}
                       className={classes.popper}
                       onClose={() => setPhoneOpen(false)}>
        <MuiCore.Grid >

          <MuiCore.Grid item xs={12}>

            <MuiCore.Grid container spacing={2}
                          style = {{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 20}}
                          alignItems='center'>
              {/* <MuiCore.Grid item>
                <div className={classes.raisedIcon}>
                  <ServiceIcons.OutgoingCallIcon color='primary'/>
                </div>
              </MuiCore.Grid> */}
              <MuiCore.Grid item className={classes.title}>
                {this.props.t('Outcalls')}
              </MuiCore.Grid>
              <MuiCore.Grid item >
                <MuiCore.IconButton onClick={() => setPhoneOpen(false)}>
                  <CloseIcon/>
                </MuiCore.IconButton>
              </MuiCore.Grid>
            </MuiCore.Grid>

            <MuiCore.Grid item xs={12}
                          style={{paddingLeft: 20,
                                  paddingTop: 0,
                                  marginTop: -8,
                                  fontFamily: 'Sofia-bold'}}>
              Call From
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12} style={{paddingLeft: 20, paddingRight: 20}}>
              <MuiCore.Select value={this.state.phoneNumberId}
                              fullWidth
                              onChange={(event) => this.phoneNumberChanged(event.target.value)}
                              className={classes.numberSelect}
                              input={<MuiCore.OutlinedInput/>}>
                {user.patchNumbers.map(number =>(
                  <MuiCore.MenuItem key={number.phoneNumberId}
                                    className={classes.numberSelect}
                                    value={number.phoneNumberId}>
                    {Formatters.formatPhoneNumber(number.phoneNumber)}
                  </MuiCore.MenuItem>                    
                ))}
              </MuiCore.Select>
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12} style={{paddingTop: 10, paddingLeft: 20, fontFamily: 'Sofia-bold'}}>
              Call To
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12} style={{paddingLeft: 20, paddingRight: 20,marginBottom:20, marginLeft: 20, marginRight: 20}}>          
                <PhoneTextFieldWithFlag className={classes.numberEntry}
                  value={this.props.outdialNumber}  
                  insertFunction={this.setInsertFunction}
                  onPhoneNumberChange={this.props.setOutdialNumber}
                  variant='outlined'
                  caller='phonepad'
                  regionChange={this.changeRegion}
                />
              {/* <PhoneTextField className={classes.numberEntry}
                              value={this.props.outdialNumber}
                              onChange={this.props.setOutdialNumber}
                              fullWidth
                              fontSize='small'
                              insertfunction={this.setInsertFunction}
                              variant='outlined'/> */}
            </MuiCore.Grid>     
            
            <MuiCore.Grid container spacing={1}
                          style={{ marginBottom: 20, maxWidth:'220px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto'}}
                          justifyContent='center'>
              {this.buttonText.map(button => (
                <MuiCore.Grid item key={button.value}
                              className={classes.keyPadButtonBox}>
                  <MuiCore.Button className={classes.keyPadButton}
                                  onClick={() => this.keyPad(button.value)}>
                    <div className={classes.keyPadNumber}>
                      {button.value}
                    </div>
                    <div className={classes.keyPadLetters}>
                      {button.letters}
                    </div>
                  </MuiCore.Button>
                </MuiCore.Grid>
              ))}

              <MuiCore.Grid item 
                            className={classes.keyPadButtonBox}>
                <MuiCore.IconButton component="span" color="secondary" onClick={this.startOutcall}
                                    disabled={!callEnabled}>
                  <CallIcon  />
                </MuiCore.IconButton>
              </MuiCore.Grid>
              <MuiCore.Grid item 
                            className={classes.keyPadButtonBox}>
                <MuiCore.IconButton component="span" onClick={hangup} color="secondary"
                                    disabled={callState !== 'open'}>
                  <CallEndIcon    />
                </MuiCore.IconButton>
              </MuiCore.Grid>
              <MuiCore.Grid item  
                            className={classes.keyPadButtonBox}>
                <MuiCore.IconButton component="span"  color={phoneMuted ? 'primary' : 'secondary'} onClick={toggleMute}
                                    disabled={callState !== 'open'} >
                  <MicOffIcon />
                </MuiCore.IconButton>
              </MuiCore.Grid>
            </MuiCore.Grid>
          </MuiCore.Grid>
        </MuiCore.Grid>
      </MuiCore.Popover>);
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    callState : phoneSelectors.getCallState(state),
    phoneOpen : phoneSelectors.getPhoneOpen(state),
    phoneOutcall : phoneSelectors.getPhoneOutcall(state),
    phoneMuted : phoneSelectors.getPhoneMuted(state),
    outdialNumber : phoneSelectors.getOutdialNumber(state), 
  });
};

const mapDispatchToProps = {
  setPhoneOpen : phoneActions.setPhoneOpen,
  outcall : phoneActions.outcall,
  hangup : phoneActions.hangup,
  toggleMute : phoneActions.toggleMute,
  dtmf : phoneActions.dtmf,
  setOutdialNumber : phoneActions.setOutdialNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslation()(PhonePad)));

